const config = {
    appUrl : "http://localhost:3000",
    // apiUrl : "https://api.webweb.ai"
    apiUrl : "https://api.allpos.in"
}
  
export default config